module.exports = __webpack_public_path__ + "img/hair_back_male_short_mask.f42da6cc.png";